import React, { useEffect } from 'react';

const Products: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main id="main-content" className="w-full bg-canvas text-text-primary" role="main">
            {/* Page Title */}
            <section className="pt-32 pb-16 px-6 md:px-16 lg:px-24 text-center">
                <h1 className="">
                    Products
                </h1>
            </section>

            {/* Section 1 - Nura */}
            <section className="relative w-full md:min-h-screen md:flex md:flex-col md:justify-center bg-canvas pb-24 md:pb-32">
                <div className="w-full px-6 md:px-28 flex flex-col-reverse md:flex-row items-center justify-between gap-12 md:gap-40">
                    {/* Text Area */}
                    <div className="max-w-lg">
                        <h2 className="mb-6 md:mb-8">
                            Nura
                        </h2>
                        <p className="text-balance leading-relaxed">
                            Adaptive meditation engine that meets your mind exactly where it is.
                            Nura was built on a foundation of comprehensive neuro-scientific research. It is also our first product and exploration of adaptive technology for daily life.
                        </p>
                        <a
                            href="https://www.nurameditation.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-6 md:mt-8 inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-text-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors focus-visible:outline-2 focus-visible:outline-text-primary focus-visible:outline-offset-4 focus:outline-none"
                        >
                            Explore
                        </a>
                    </div>

                    {/* Image Area */}
                    <div className="w-full max-w-[500px] md:max-w-[600px] flex-shrink-0">
                        <div
                            className="relative w-full aspect-square rounded-2xl overflow-hidden isolate flex items-center justify-center p-8"
                            style={{ transform: 'translateZ(0)', WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}
                        >
                            {/* Mesh Gradient background */}
                            <div className="absolute inset-0 w-full h-full bg-[#0A0A0A] overflow-hidden">
                                <img
                                    src="/image-mesh-gradient-15.png"
                                    className="w-full h-full object-cover"
                                    alt=""
                                />
                            </div>

                            {/* Nura Text */}
                            <h1 className="relative z-10 text-white text-h1 md:text-hero select-none pointer-events-none tracking-tight">
                                Nura
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Products;
